import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
   OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import profile from "../assets/profile.png";
import { useLocation } from "react-router-dom";
 import changePass from "../assets/change_pass_ico.png";
import { useDispatch, useSelector } from "react-redux";

import eyeOpen from '../assets/eye-open.svg'
import eyeClose from '../assets/eye-close.svg'
import {
  changePassword,
  getUser,
  reset,
   
} from "../redux/slices/authSlice";
import Loader from "../components/Loader/Loader";
import api from "../Api";

const Profile = () => {
  let location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");

  const authData = useSelector((state) => state.auth.data);
  const user = useSelector((state) => state.auth.user);
  const authIsSuccess = useSelector((state) => state.auth.isSuccess);
  const userUpdateSuccess = useSelector((state) => state.auth.isUpdateSuccess);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const dispatch = useDispatch();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const showError = (msg) => {
    setError(msg);
    setTimeout(() => {
      setError("");
    }, 3000);
  };

  const handleSubmit = () => {
    if (!newPassword || !confirmPassword) {
      showError("All Fields Required");
    }else if (newPassword.length < 6 || confirmPassword.length < 6 ){
      showError("password must be at least 6 characters");  
    }
     else if (newPassword === confirmPassword) {
      dispatch(changePassword({ id: authData.user_id, newPassword }));
      dispatch(reset());
      setConfirmPassword("");
      setNewPassword("");
    } else {
      showError("Passwords do not match");
    }
  };
  useEffect(() => {
    if (authData.access_token !== "") {
      api.defaults.headers.common.Authorization = authData?.access_token
        ? `Bearer ${authData?.access_token}`
        : "";
      dispatch(getUser(authData?.user_id));
    }
  }, [dispatch, authData]);

  useEffect(() => {
    setUserName(user?.user_name);
    setEmail(user?.email);
    setPhone(user?.phone);
  }, [user]);

  useEffect(() => {
    if (authIsSuccess || userUpdateSuccess) {
      if(userUpdateSuccess){
        let user = localStorage.getItem("user") || sessionStorage.getItem('user');
        let parse = JSON.parse(user);
        parse.username = userName;
        sessionStorage.setItem("user",JSON.stringify(parse));
        localStorage.setItem("user",JSON.stringify(parse));
        window.location.reload();
      }
      setTimeout(() => {
        dispatch(reset());
      }, 3000);
    }
  }, [dispatch,authIsSuccess, userUpdateSuccess,userName]);

  return (
    <Layout>
      <Loader message={"Loading"} show={isLoading} />
      <Grid container>
        <Grid
          item
          md={12}
          my={1}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography className="heading">
            {location.pathname === "/view_profile"
              ? "Profile"
              : "Change Password"}
          </Typography>
          {error && (
            <Alert variant="filled" severity="error">
              {error}
            </Alert>
          )}
          {authIsSuccess && (
            <Alert variant="filled" severity="success">
              Password changed successfully
            </Alert>
          )}
          {userUpdateSuccess && (
            <Alert variant="filled" severity="success">
              User updated successfully
            </Alert>
          )}
        </Grid>
        {location.pathname === "/view_profile" && (
          <Grid item md={12} lg={12} mt={2}>
            <Box
              variant="div"
              className="card"
              display="flex"
              justifyContent={"center"}
              p={3}
            >
              <Box variant="div" width={"350px"}>
                <img
                  src={profile}
                  style={{ display: "block", margin: "10px auto" }}
                  alt="profile"
                />
                <Box variant="div" mt={2}>
                  <div style={{ display: "grid" }}>
                    <label style={{ marginBottom: "10px" }}>Name</label>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      value={userName}
                      disabled
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div style={{ display: "grid", marginTop: "10px" }}>
                    <label style={{ marginBottom: "10px" }}>Email</label>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      value={email}
                      disabled
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  {/* <div style={{ display: "grid", marginTop: "10px" }}>
                    <label style={{ marginBottom: "10px" }}>Phone Number</label>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      value={phone}
                      disabled
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div> */}
                  {/* <Button
                    variant="contained"
                    size="large"
                    sx={{
                      fontSize: "20px",
                      background: "#358ad4",
                      padding: "3% 24%",
                      margin: "20px auto",
                      display: "block",
                      "&:hover": {
                        background: "#358ad4da",
                      },
                    }}
                    onClick={() => {
                      api.defaults.headers.common.Authorization =
                        authData?.access_token
                          ? `Bearer ${authData?.access_token}`
                          : "";
                      if (!userName || !phone) {
                        showError("Username or Phone should not empty");
                      } else if (phone.length < 10 || phone.length > 10) {
                        showError("Phone number must be 10 digit");
                      } else {
                       
                        dispatch(updateUser({id:authData.user_id,username:userName,phone:phone}));
                      }
                    }}
                  >
                    Save
                  </Button> */}
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
        {location.pathname === "/change_password" && (
          <Grid item md={12} lg={12} mt={2}>
            <Box
              variant="div"
              className="card"
              display="flex"
              justifyContent={"center"}
              p={1}
            >
              <Box variant="div" width={"500px"} mt={3}>
                <img
                  src={changePass}
                  alt="password_icon"
                  style={{ margin: "10px auto", display: "block" }}
                />
                <Typography
                  variant="subtitle1"
                  textAlign={"center"}
                  fontSize={24}
                  fontWeight={600}
                >
                  Change Your Password
                </Typography>
                <Typography
                  variant="subtitle1"
                  lineHeight={1.5}
                  textAlign={"center"}
                  color={"#656565"}
                  fontSize={16}
                  mt={1}
                  mb={4}
                  fontWeight={400}
                >
                  Enter a new password below to <br />
                  change your password
                </Typography>
                <div style={{ display: "flex", justifyContent:"center" }}>
                  <div style={{ display: "grid", marginTop: "10px",width:"68%"  }}>
                  <label style={{ marginBottom: "10px" }}>
                    Enter New Password
                  </label>
                  <FormControl  sx={{width:"100%"}}  variant="outlined" size="large">
                    <OutlinedInput
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      autoComplete="new-pass"
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {!showPassword ?  <img src={eyeClose} width={'20px'} alt="eye_ico"/> : <img src={eyeOpen} width={'20px'} alt="eye_ico"/>}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent:"center" }}>
                <div style={{ display: "grid", marginTop: "20px",width:"68%" }}>
                  <label style={{ marginBottom: "10px" }}>
                    Confirm New Password
                  </label>
                  <FormControl sx={{width:"100%"}}  variant="outlined" size="large">
                    <OutlinedInput
                      type={showPassword1 ? "text" : "password"}
                      placeholder="Enter your password"
                      autoComplete="new-pass"
                      value={confirmPassword}
                      
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword1}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {!showPassword1 ? <img src={eyeClose} width={'20px'} alt="eye_ico"/> : <img src={eyeOpen} width={'20px'} alt="eye_ico"/>}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
                </div>
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    fontSize: "16px",
                    background: "#358ad4",
                    padding: "3% 20%",
                    margin: "50px auto",
                    display: "block",
                    borderRadius: "16px !important",
                    "&:hover": {
                      background: "#358ad4da",
                    },
                  }}
                  onClick={handleSubmit}
                >
                  Update Password
                </Button>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};

export default Profile;
